export enum JourneyEvent {
  Recalculation = "Recalculation",
  JobUpdate = "JobUpdate",
  Complete = "Complete",
}
